import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import MainNav from "../Navbars/MainNav";
import Sidebar from "../Navbars/Sidebar";
import { Grid, Layout } from "antd";
import { useGetMeQuery } from "../../../redux/api/AuthApi/authApi";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AdminLayout = () => {
  useGetMeQuery(); // Periodic refresh of user permissions/profile
  const location = useLocation();

  const selectedKey = location.pathname;
  const screens = useBreakpoint();
  const marginLeft = screens.lg ? 200 : 0;
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <MainNav />

      <Layout>
        <Sidebar selectedKey={selectedKey} />

        <Layout
          style={{
            marginLeft: marginLeft,
          }}
        >
          <Content
            style={{
              margin: "0",
              minHeight: "100%",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
